import echarts from 'echarts';
import api from '@/api';
import discovery from './discovery'
import { Message } from 'element-ui'
import sysInit from './sysInit'
const state = {
    mapShowFlag: false,
    emotionShowFlag: false,
    settingShowFlag:false
}
const getters = {
    mapShowFlag(state) { return state.mapShowFlag },
    emotionShowFlag(state) { return state.emotionShowFlag }
}
const actions = {
    echartInit(context, mapData) {
        if (mapData.type == "map" || mapData.type == "minmap") {
            if(!mapData.data.nodes || (mapData.data.nodes && mapData.data.nodes.length == 0) ){
                return ;
            }
            // if(!document.getElementById('keyword-echart')){
            //     return ;
            // }
            let myChart = '';
            let fontSize = 14 ;
            let repulsion = 300 ;
            if(mapData.type == 'map'){
                if(!document.getElementById('map')){
                    return ;
                }
                myChart = echarts.init(document.getElementById('map'));
                mapData.data.nodes.forEach((item,index) => {
                    if(index == 0 ){
                        item.symbolSize = 20;
                    }else{
                        item.symbolSize = 16;
                    }
                    
                })
                fontSize = 14 ;
                repulsion = 300 ;
            }else{
                if(!document.getElementById('minmap')){
                    return ;
                }
                myChart = echarts.init(document.getElementById('minmap'));
                mapData.data.nodes.forEach((item,index) => {
                    if(index == 0 ){
                        item.symbolSize = 12;
                    }else{
                        item.symbolSize = 8;
                    }
                    
                })
                fontSize = 8 ;
                repulsion = 100 ;
            }
            if(!myChart){
                return ;
            }
            // let myChart = echarts.init(document.getElementById('keyword-echart'));
            let option = {
                backgroundColor: {
                    type: 'radial',
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [{
                        offset: 0, color: 'grey'
                    }, {
                        offset: 1, color: 'black'
                    }],
                    globalCoord: false
                },
                color: {
                    type: 'radial',
                    x: 0.4,
                    y: 0.3,
                    r: 1,
                    colorStops: [{
                        offset: 0,
                        color: 'rgb(129, 227, 238)'
                    }, {
                        offset: 1,
                        color: 'rgb(25, 183, 207)'
                    }],
                    globalCoord: false
                },
                tooltip: {
                    show: false
                },
                animation: false,
                series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        data: mapData.data.nodes,
                        links: mapData.data.links,
                        roam: true,
                        focusNodeAdjacency: true,
                        label: {
                            normal: {
                                show:true,
                                color: 'white',
                                fontSize:fontSize,
                                position: 'right'
                            }
                        },
                        force: {
                            repulsion:repulsion
                        }
                    }
                ]
            };
            myChart.setOption(option);
            myChart.on('click', function (params) {
                if (params.dataType === 'node') {
                    let keyword = params.data.name;
                    context.dispatch("sysInit/changeQueryNote", keyword,{ root: true });
                    // for (const collection of discovery.state.collections) {
                        context.dispatch("discovery/fetchDisResults", { collections: discovery.state.collections, input:keyword, search_flag: 'map' },{ root: true });
                    // }
                }
            });
        }

        if (mapData.type == "emotion" || mapData.type == "minemotion") {
            let myChart = '';
            let fontSize = 14;
            let bottom = 100;
            let top = 20;
            let minuteArray = ['0', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50',
            '55', '60', '65', '70', '75', '80', '85', '90', '95', '100', '105', '110', '115', '120'];//
            let opArray = [,80,80,82,80,78,80,82,80,78,80,
            82,80,79,78,76,74,72,70,68,66,64,62,60,58];
            let customerArray = [,-20,-10,-5,-2,0,-2,-10,-20,-28,-30,
            -28,-26,-28,-30,-32,-34,-36,-38,-40,-42,-44,-46,-48,-50];
            if(mapData.type == 'emotion'){
                if(!document.getElementById('emotion')){
                    return ;
                }
                myChart = echarts.init(document.getElementById('emotion'));
                fontSize = 14;
                bottom = 100;
                top = 20;
            }else{
                if(!document.getElementById('minemotion')){
                    return ;
                }
                myChart = echarts.init(document.getElementById('minemotion'));
                fontSize = 8;
                bottom = 0;
                top = 0;
            }
            if(!myChart){
                return ;
            }
            let option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        let timeItem;
                        let nameItem;
                        if (params[0].name == 0) {
                            nameItem = params[0].name;
                            timeItem = '分';
                            params[0].value = '0';
                            params[1].value = '0';
                        } else if (params[0].name == 60) {
                            nameItem = '1';
                            timeItem = '分';
                        } else if (params[0].name == 120) {
                            nameItem = '2';
                            timeItem = '分';
                        } else {
                            nameItem = params[0].name;
                            timeItem = '秒';
                        }
                        return '時間：' + nameItem + timeItem + '<br />' + 
                        params[0].seriesName + '：' + params[0].value + '%' + '<br />' + 
                        params[1].seriesName + '：' + params[1].value + '%';
                    }
                },
                legend: {
                    top: top,
                    data: ['オペレーター', 'お問い合わせ者'],
                    textStyle: {
                        fontSize :fontSize
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: ['0%', '30%'],
                    axisLabel: {
                        formatter: function (val) {
                            if (val == 0) {
                                return '0分';
                            } else if (val == 60) {
                                return '1分';
                            } else if (val == 120) {
                                return '2分';
                            } else {
                                return val + '秒';
                            }
                        },
                        interval: 11
                    },
                    axisLine: {
                        symbol: ['none', 'arrow']
                    },
                    data: minuteArray
                },
                yAxis: {
                    show: true,
                    name: '感情指数',
                    nameTextStyle: {
                        fontSize: fontSize,
                        fontWeight: 'bold'
                    },
                    type: 'value',
                    min: -100,
                    max: 100,
                    axisLabel: {
                        formatter: function (val) {
                            return val + '%';
                        }
                    }
                },
                grid: {
                    bottom: bottom
                },
                series: [
                    {
                        name: "オペレーター",
                        data: opArray,
                        type: 'line',
                        smooth: true
                    },
                    {
                        name: "お問い合わせ者",
                        data: customerArray,
                        type: 'line',
                        smooth: true
                    },
                ]
            };
            myChart.setOption(option);
        }
        
    },
    //
    updatePersonalConfig(context, data) {
        api.updateKeywordRate(data).then((res) => {
            if(res.data.d3){
                context.dispatch("echartInit",{type:'map',data:res.data.d3});
                if(res.data.d3.nodes && res.data.d3.nodes.length > 0){
                    context.commit("discovery/changeMapData",res.data.d3 , {root: true});
                }
            }
            // Message.success({message: `最大ノード数を保存しました。`});
            Message.success({message: sysInit.state.html_const.cons_246_max_nodes_success_msg});
        }, (err) => {
            console.log(err);
        });
    },

  


}
const mutations = {
    changeMapFlag(state,flag) {
        state.mapShowFlag = flag;
    },
    changeEmotionFlag(state,flag) {
        state.emotionShowFlag = flag;
    },
    changeSettingsFlag(state,flag) {
        state.settingShowFlag = flag;
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
